<div class="flex h-full flex-col px-3 py-2">
  <h2 class="shrink-0 text-sm font-semibold text-slate-700 mb-2">Facturas por estado</h2>
  @if (legend().length === 0) {
    <div class="flex-1 flex items-center justify-center text-slate-400 text-sm">Sin datos</div>
  } @else {
    <div class="flex-1 min-h-0 flex gap-4 items-center">
      <!-- El donut ocupa toda la altura disponible manteniendo proporción cuadrada -->
      <div class="h-full min-w-0 flex-1" style="aspect-ratio: 1 / 1; max-height: 100%; max-width: 100%;">
        <p-chart class="block h-full w-full" type="doughnut" [data]="chartData()" [options]="chartOptions" />
      </div>
      <ul class="shrink-0 space-y-1.5 overflow-auto" style="max-height: 100%; min-width: 120px;">
        @for (seg of legend(); track seg.key) {
          <li class="flex items-center gap-2 text-xs">
            <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="seg.color"></span>
            <span class="text-slate-600 truncate">{{ seg.key }}</span>
            <span class="font-semibold text-slate-900 ml-auto pl-2 tabular-nums">{{ seg.value }}</span>
          </li>
        }
      </ul>
    </div>
  }
</div>
